import { ReactNode } from 'react'
import {
	Button,
	ButtonProps,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	SxProps,
	Typography
} from '@mui/material'
import { isLightMode } from 'theme'

export type AlertModalProps = {
	icon?: ReactNode
	isOpen: boolean
	title: string | React.ReactNode
	text: string | React.ReactNode
	onClose: () => void
	textSx?: SxProps
	buttonSx?: SxProps
	buttonProps?: ButtonProps
}

export const AlertModal: React.FC<AlertModalProps> = ({
	icon,
	isOpen,
	onClose,
	title,
	text,
	textSx,
	buttonSx,
	buttonProps
}) => (
	<Dialog
		open={isOpen}
		onClose={onClose}
		maxWidth={false}
		PaperProps={{
			sx: ({ palette }) => ({
				width: '300px',
				boxShadow: isLightMode(palette) ? '0px 1px 8px 02px #E8E8FF' : '0px 1px 8px 02px #1D1D30',
				borderRadius: 3
			})
		}}
		hideBackdrop
	>
		<DialogTitle
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			gap={1}
			sx={{ pb: 2, textAlign: 'center' }}
		>
			{!!icon && icon}
			<span>{title}</span>
		</DialogTitle>

		<DialogContent sx={{ px: 6 }}>
			<Typography align="center" sx={{ fontSize: '0.95rem', ...textSx }}>
				{text}
			</Typography>
		</DialogContent>

		<DialogActions sx={{ display: 'flex', justifyContent: 'center', pt: 4 }}>
			<Button
				size="large"
				variant="text"
				sx={{ color: 'text.primary', ...buttonSx }}
				onClick={onClose}
				{...buttonProps}
			>
				Close
			</Button>
		</DialogActions>
	</Dialog>
)
